import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import {BitacoraComponent} from 'recupero-bitacora'
import { Auth } from 'recupero-comunes'
import { useDispatch, useSelector } from 'react-redux'
const BitacoraGestion = ({showBitacora,handleCloseBitacora}) => {
    const { rutUsuario, rutOrganizacion } = Auth.currentUser()
    const data_encargado_cia = useSelector((state) => state.encargado_compania)
    const { llaves} = data_encargado_cia
  return (
    <div>
      <Modal size="xl" show={showBitacora} onHide={handleCloseBitacora}>
        
        <Modal.Body>
          <BitacoraComponent user={rutUsuario} rutcia={rutOrganizacion} idCaso={llaves && llaves["idCaso"]}/> 
        </Modal.Body>
        
          <Modal.Footer>
            <Button variant='primary' onClick={handleCloseBitacora}>
              Cerrar
            </Button>
          </Modal.Footer>
        
      </Modal>
    </div>
  )
}

export default BitacoraGestion
